import { Injectable } from '@angular/core';
import { EnvDomainVariables } from './env.service';

@Injectable({
  providedIn: 'root',
})
export class EnvDemoService {
  getDomainInfo(): EnvDomainVariables {
    return {
      _enableErrorLogging: false,
      _enableRefreshToken: false,
      isMagellan: '0',
      _env: 'demo',
      _apiUrl: 'https://demo-api.p-cis.com/api/',
      _production: true,
      _redirectUri: 'https://demo-login.p-cis.com/',
      _responseType: 'token id_token',
      _issuer: 'https://pcisdemoadb2c.b2clogin.com/621e03aa-8809-4bc5-b90e-d42eeeaa6d32/v2.0/',
      _strictDiscoveryDocumentValidation: false,
      _tokenEndpoint: 'https://pcisdemoadb2c.b2clogin.com.b2clogin.com/pcisdemoadb2c.onmicrosoft.com/oauth2/v2.0/token?p=b2c_1_signin',
      _loginUrl: 'https://pcisdemoadb2c.b2clogin.com/pcisdemoadb2c.onmicrosoft.com/oauth2/v2.0/token?p=B2C_1_Signin',
      _clientId: '88b3312b-8c7f-4278-908b-7c18fdd48b34',
      _scope: 'openid profile https://pcisdemoadb2c.onmicrosoft.com/api/pcisdemo.read',
      _skipIssuerCheck: true,
      _clearHashAfterLogin: true,
      _oidc: true,
      _logoutUrl: 'https://pcisdemoadb2c.b2clogin.com/pcisdemoadb2c.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/logout?post_logout_redirect_uri=https://demo-login.p-cis.com/',
      _signInURL: 'https://pcisdemoadb2c.b2clogin.com/pcisdemoadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_signin_signup_frp',
      _signInURLSSO: 'https://pcisdemoadb2c.b2clogin.com/pcisdemoadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_SIGNUP_FRP_SSO',
      _adb2cTenantUrl: 'https://pcisdemoadb2c.b2clogin.com/pcisdemoadb2c.onmicrosoft.com/oauth2/v2.0/',
      _magicLink: 'https://opeekab2cdev.b2clogin.com/opeekab2cdev.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_WITH_EMAIL',
      _authEndpoint: 'https://pcisdemoadb2c.b2clogin.com/pcisdemoadb2c.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/authorize',
      _magicLinkScope : 'https://pcisdemoadb2c.b2clogin.com/pcisdemoadb2c.onmicrosoft.com/B2C_1A_SIGNIN_WITH_EMAIL/oauth2/v2.0/authorize',
     _launchDarklyClientId: '69120006711aa209b78d9aaf',
      _intercomAppId: 'bqgvwybf'
    };
  }
}
